// @flow
import * as React from 'react';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

type Props = {
  children: Function,
  createOrgWhileUnauthed: (
    data: CreateOrganizationUnauthedInput
  ) => Promise<{ data: createOrganizationUnauthedMutation }>,
};

class OrganizationCreateContainer extends React.Component<Props, void> {
  render() {
    return this.props.children({
      createOrgWhileUnauthed: this.props.createOrgWhileUnauthed,
    });
  }
}

const withUnauthedMutation = graphql(
  gql`
    mutation createOrganizationUnauthed($input: CreateOrganizationUnauthedInput!) {
      createOrganizationUnauthed(input: $input) {
        organization {
          id
          uuid
          name
          city
          state
        }
        error {
          message
          code
          fieldErrors {
            field
            message
          }
        }
      }
    }
  `,
  {
    props: ({ mutate }) => ({
      createOrgWhileUnauthed: (input: CreateOrganizationUnauthedInput) => {
        return mutate({
          variables: { input },
        });
      },
    }),
  }
);

export { OrganizationCreateContainer };

export default compose(withUnauthedMutation)(OrganizationCreateContainer);
